













































import Vue from 'vue';
import Component from 'vue-class-component';
import {Prop} from 'vue-property-decorator';
import BindAttrs from '@/utils/binds-attrs';
import AmetrasTextFieldTemplate from '@/fields/text/AmetrasTextFieldTemplate.vue';
import {FIELD_EVENTS_INSTANCE, VueOnMapType} from '@/fields/field-events';
import {EMAIL_VALIDATOR_INSTANCE} from '@/utils/email-validator';

@Component({
  components: {AmetrasTextFieldTemplate},
  mixins: [BindAttrs]
})
export default class AmetrasEmailFieldTemplate extends Vue {

  @Prop() noValidate!: boolean;
  @Prop() readonly!: boolean;

  @Prop({
    default: false
  }) required!: boolean;
  /**
   * Indicates that all errors should be shown
   */
  @Prop() forceShowErrors!: boolean;

  rules = [(currentValue: string) => {
    if (!this.noValidate) {
      if (this.required && (this.forceShowErrors || !this.readonly) && (!currentValue || currentValue.trim().length === 0)) {
        return 'Bitte geben Sie eine gültige E-Mail an!';
      }
      if ((this.forceShowErrors || !this.readonly) && currentValue && !EMAIL_VALIDATOR_INSTANCE.validate(currentValue) && currentValue.trim().length) {
        return 'Die eingegebene E-Mail ist ungültig';
      }
    }
    return !this.$attrs.error; // if any error from outside, return false
  }];

  passthroughAllEventsVueOnMap: VueOnMapType =
      FIELD_EVENTS_INSTANCE.buildPassthroughVueOnMapForAllEvents((eventName, eventArgs) => {
        this.$emit(eventName, eventArgs);
      });

  private isValidEmail() {
    return this.$attrs.value && EMAIL_VALIDATOR_INSTANCE.validate(this.$attrs.value);
  }

  private inDataTable() {
    return this.$attrs['style-context'] && this.$attrs['style-context'] === 'DATATABLE';
  }

  private inFormular() {
    return this.$attrs['style-context'] && this.$attrs['style-context'] === 'FORMULAR';
  }

  private openMailClient() {
    if (this.$attrs.value) {
      window.location.href = `mailto:${this.$attrs.value}`;
    }
  }
}
